export default "<p>component-can-deactivate works!</p>\n";